import { useFormState } from '@carboledger/ui';
import { FACILITY_KINDS, parseFacilityValue } from '@/config/formOptions';
import { TerminalField } from '@/components/common';

/**
 * Props:
 *   sites     the session's sites, which carry their terminals
 *   disabled  locked once the order already fixed a terminal
 */
export const FulfillTerminalField = ({ sites, disabled }) => {
  const { values } = useFormState();

  // A back-to-back facility has no terminals — the server nulls the column for them too.
  if (parseFacilityValue(values.facilityId).kind === FACILITY_KINDS.backToBack) return null;

  return <TerminalField sites={sites} required disabled={disabled} />;
};
